export default __webpack_public_path__ + "static/media/avrata1.429db354.jpg";